import React from "react";
import "./AnswerOption.css";

export default function AnswerOption({
  optionKey,
  optionTitle,
  selectedOption,
  onCheck,
}) {
  const handleCheckboxChange = (optionKey) => {
    onCheck(optionKey);
  };
  return (
    <>
      <input
        type="checkbox"
        className="radioBtn"
        checked={optionKey === selectedOption}
        onChange={() => console.log(optionKey)}
      />
      <span
        className="answerOptionCustomRadioBtn"
        onClick={() => handleCheckboxChange(optionKey)}
      ></span>
      <span className="answerOptionTitle">{optionTitle}</span>
    </>
  );
}